module.exports = __webpack_public_path__ + "img/dynamic_trackers_logo.8fd0ecb7.png";